export default {
    EARNING: [
        {
            key: 'LESS_THAN_FIVE_THOUSAND',
            value: 'Less than ₹5,000'
        },
        {
            key: 'BETWEEEN_FIVE_THOUSAND_AND_TEN_THOUSAND',
            value: 'Between ₹5,000 and ₹10,000'
        },
        {
            key: 'MORE_THAN_FIVE_THOUSAND',
            value: 'More than ₹10,000'
        },
    ],
};
